import { use } from 'react';
import FundContext from './FundContext';

const useFundContext = () => {
  const context = use(FundContext);
  if (!context) {
    throw new Error('useFundContext must be used within a FundProvider');
  }
  return context;
};
export default useFundContext;
